import { Anchoring } from './Anchoring';
export default class AnchoringHeavingUpData extends Anchoring {
    constructor(anchor, freeText) {
        super(anchor, freeText);
    }
}
//# sourceMappingURL=AnchoringHeavingUpData.js.map